import { DEFAULT_LANG, LANG_PREFIX, UNLOCALIZED_PREFIXES } from "./config";

/** Language encoded in a pathname, or the default when there is no prefix. */
export const langFromPath = (pathname = "/") => {
  for (const [code, prefix] of Object.entries(LANG_PREFIX)) {
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) return code;
  }
  return DEFAULT_LANG;
};

/** The pathname without its language prefix, always starting with a slash. */
export const stripLang = (pathname = "/") => {
  for (const prefix of Object.values(LANG_PREFIX)) {
    if (pathname === prefix) return "/";
    if (pathname.startsWith(`${prefix}/`)) return pathname.slice(prefix.length) || "/";
  }
  return pathname || "/";
};

export const isUnlocalized = (pathname = "/") =>
  UNLOCALIZED_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));

/**
 * Rewrites a path for a language. Accepts prefixed or unprefixed input so it is
 * safe to call on a value that has already been localized.
 *
 *   withLang("/articles", "tr")     -> "/tr/articles"
 *   withLang("/tr/articles", "en")  -> "/articles"
 *   withLang("/admin/messages","tr")-> "/admin/messages"   (never localized)
 */
export const withLang = (path = "/", lang = DEFAULT_LANG) => {
  if (typeof path !== "string" || !path.startsWith("/")) return path;

  const bare = stripLang(path);
  if (isUnlocalized(bare)) return bare;

  const prefix = LANG_PREFIX[lang];
  if (!prefix) return bare;
  return bare === "/" ? prefix : `${prefix}${bare}`;
};

/** "8 min read" -> localized string via the common.minRead template. */
export const formatReadTime = (readTime, t) => {
  const minutes = parseInt(String(readTime), 10);
  if (Number.isNaN(minutes)) return readTime;
  return t("common.minRead").replace("{{count}}", minutes);
};
